const THREE_MONTHS_WINDOW_MONTHS = 3

export const SESSION_EXPIRED_MODAL_LAST_SHOWN_KEY = 'pg19_session_expired_modal_last_shown_at'

function addMonths(timestampMs: number, months: number): number {
  const date = new Date(timestampMs)
  date.setMonth(date.getMonth() + months)
  return date.getTime()
}

export function isOutsideThreeMonthWindow(lastShownAtMs: number, nowMs: number = Date.now()): boolean {
  const nextAllowedAt = addMonths(lastShownAtMs, THREE_MONTHS_WINDOW_MONTHS)
  return nowMs >= nextAllowedAt
}

export function shouldShowSessionExpiredModal(storage: Storage = window.localStorage, nowMs: number = Date.now()): boolean {
  try {
    const raw = storage.getItem(SESSION_EXPIRED_MODAL_LAST_SHOWN_KEY)
    if (!raw) return true

    const parsed = Number(raw)
    if (!Number.isFinite(parsed) || parsed <= 0) {
      return false
    }

    return isOutsideThreeMonthWindow(parsed, nowMs)
  } catch {
    // Если storage недоступен/повреждён, выбираем безопасный anti-spam fallback.
    return false
  }
}

export function markSessionExpiredModalShown(storage: Storage = window.localStorage, nowMs: number = Date.now()): void {
  try {
    storage.setItem(SESSION_EXPIRED_MODAL_LAST_SHOWN_KEY, String(nowMs))
  } catch {
    // no-op: storage может быть недоступен в privacy mode
  }
}
